(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Signed in? ───────────────────────────────────────────
     The dashboard is remote/src/pages/dashboard — every machine on
     your account, with its stats and downloads. It is served from
     THIS origin at /remote, so the button is a same-origin link and
     no host needs configuring here.

     Signed out, the button sends you to +Ai auth and returns you to
     /remote; signed in it goes straight there.

     Session detection reads the domain-wide `auth` cookie that
     framework/src/utilities/supabase.js writes — the same full
     session every app on *.add.ai shares. That is why this resolves
     at all: the older localStorage scan only saw a session that this
     exact origin had stored, so arriving from another +Ai app always
     read as signed out. localStorage is still checked first, because
     on this origin supabase-js's own entry is the authoritative copy.

     A cookie whose session has expired is treated as signed out —
     showing "Dashboard" and landing the user on a sign-in redirect is
     worse than showing "Sign In" to someone who is already signed in. */
  // auth.add.ai — NOT auth.beta.add.ai. The auth app has been live on the
  // apex host; the beta hostname is the one the framework was hardcoded to
  // for months, and every redirect through it landed on the wrong app. This
  // mirrors framework/src/components/Auth.jsx, which now defaults the same way.
  var AUTH_URL = 'https://auth.add.ai';
  var DASHBOARD_PATH = '/remote';

  function live(session){
    if (!session || !session.access_token) return false;
    // expires_at is UNIX seconds; absent means "cannot tell", so trust it.
    if (typeof session.expires_at === 'number' && session.expires_at * 1000 <= Date.now()) return false;
    return true;
  }

  function fromLocalStorage(){
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (/^sb-.*-auth-token$/.test(k)) {
          var v = localStorage.getItem(k);
          if (v) return JSON.parse(v);
        }
      }
    } catch (e) { /* storage blocked or half-written entry */ }
    return null;
  }

  function fromCookie(){
    try {
      var parts = document.cookie.split(/\s*;\s*/);
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (eq > 0 && parts[i].slice(0, eq) === 'auth') {
          return JSON.parse(decodeURIComponent(parts[i].slice(eq + 1)));
        }
      }
    } catch (e) { /* malformed cookie — treat as signed out */ }
    return null;
  }

  function hasSession(){
    return live(fromLocalStorage()) || live(fromCookie());
  }

  /* `/login`, not the bare origin, and the path is the whole point.
     auth.add.ai has no route for `/`, so it falls through to a client-side
     catch-all that navigates to `/login` — and that navigation DROPS THE QUERY
     STRING. Verified live: https://auth.add.ai?return=<codeflows> lands on
     https://auth.add.ai/login with no return at all, so signing in sent people
     to that app's own default page instead of back here. Naming the route
     skips the catch-all, and the param survives. */
  function signIn(){
    return AUTH_URL + '/login?return=' + encodeURIComponent(window.location.origin + DASHBOARD_PATH);
  }

  (function auth(){
    var signedIn = hasSession();
    var dash = DASHBOARD_PATH;
    var target = signedIn ? dash : signIn();

    var nav = document.getElementById('navAuth');
    var foot = document.getElementById('footAuth');
    if (nav){
      nav.dataset.state = signedIn ? 'in' : 'out';
      nav.href = target;
      nav.innerHTML = signedIn ? '<span class="dot"></span>Dashboard' : 'Sign In';
    }
    if (foot){
      foot.textContent = signedIn ? 'Your CodeFlows' : 'Sign in';
      foot.href = target;
    }
  })();

  /* ── Get CodeFlows ───────────────────────────────────────
     The builds are behind the account: you sign in, and the
     dashboard hands you the right one for your machine. So the
     public page has no download links at all — every CTA points at
     /remote, and the only thing that changes is the wording, which
     depends on whether you are already signed in. */
  (function cta(){
    var signedIn = hasSession();
    // The footer's Download links go where the CTAs go — signed in, the
    // dashboard; signed out, sign-in with the return URL — so they join this
    // list rather than hard-coding a path. Never an asset: the builds are
    // behind the account.
    ['ctaHero', 'ctaDownload', 'footDownload', 'footRemote'].forEach(function(id){
      var el = document.getElementById(id);
      if (!el) return;
      el.href = signedIn ? DASHBOARD_PATH : signIn();
      // "Get CodeFlows" reads the same whether it takes you to a download or
      // to a sign-in first — which is exactly what it does.
    });
    var nav = document.getElementById('navCta');
    if (nav){
      nav.href = signedIn ? DASHBOARD_PATH : signIn();
      nav.textContent = signedIn ? 'Dashboard' : 'Sign In';
    }
    var v = document.getElementById('dlVersion');
    if (v && signedIn) v.textContent = 'Pick your machine, or download the desktop app.';
  })();

  /* ── Mockup scaling ──────────────────────────────────────
     Each .mk is authored at a fixed design size and scaled to
     the column width, so the UI never reflows into a layout the
     real app doesn't have. */
  var mks = [].slice.call(document.querySelectorAll('.mk'));
  // Below this the mockup's own type stops being readable, so we stop
  // shrinking and let the container scroll instead.
  var MIN_SCALE = 0.62;
  mks.forEach(function(mk){
    var hint = document.createElement('p');
    hint.className = 'mk-hint';
    hint.innerHTML = 'Swipe to see the rest of the window <svg width="14" height="14"><use href="#i-arrow"/></svg>';
    mk.parentNode.insertBefore(hint, mk.nextSibling);
    mk._hint = hint;
  });
  function fit(){
    for (var i=0;i<mks.length;i++){
      var mk = mks[i];
      var dw = +mk.dataset.dw;
      var w = mk.clientWidth;
      if (!w) continue;
      var s = Math.min(1, Math.max(MIN_SCALE, w / dw));
      mk.style.setProperty('--s', s);
      mk.style.setProperty('--dw', dw + 'px');
      mk._hint.dataset.on = (dw * s > w + 4) ? '1' : '0';
    }
  }
  fit();
  window.addEventListener('resize', fit, {passive:true});
  if (window.ResizeObserver){
    var ro = new ResizeObserver(fit);
    mks.forEach(function(m){ ro.observe(m); });
  }
  document.fonts && document.fonts.ready.then(fit);

  /* ── Scroll reveals ───────────────────────────────────── */
  var reveals = [].slice.call(document.querySelectorAll('.rv, .boot'));
  if (!('IntersectionObserver' in window) || reduce){
    reveals.forEach(function(el){ el.dataset.in = '1'; });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.dataset.in = '1'; io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -10% 0px', threshold:0.06});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* ── Nav hairline once you leave the hero ─────────────── */
  var nav = document.getElementById('nav');
  var heroCta = document.querySelector('.hero .cta-row');
  var navLinks = [].slice.call(document.querySelectorAll('#navLinks a'));
  var navInd = document.getElementById('navInd');
  var here = null;

  function moveIndicator(link){
    if (link === here) return;
    here = link;
    navLinks.forEach(function(a){ a.dataset.here = a === link ? '1' : '0'; });
    if (!link){ navInd.dataset.on = '0'; return; }
    navInd.dataset.on = '1';
    navInd.style.width = link.offsetWidth + 'px';
    navInd.style.transform = 'translateX(' + link.offsetLeft + 'px)';
  }

  function spy(){
    // The section that owns the top third of the viewport is the one
    // you're reading, so that's the one the nav should point at.
    var line = window.innerHeight * 0.34, found = null;
    navLinks.forEach(function(a){
      var sec = document.querySelector(a.getAttribute('href'));
      if (!sec) return;
      var r = sec.getBoundingClientRect();
      if (r.top <= line && r.bottom > line) found = a;
    });
    moveIndicator(found);
  }

  var onScroll = function(){
    nav.dataset.stuck = window.scrollY > 8 ? '1' : '0';
    if (heroCta) nav.dataset.cta = heroCta.getBoundingClientRect().bottom < 40 ? '1' : '0';
    spy();
  };
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', function(){ var h = here; here = null; moveIndicator(h); }, {passive:true});

  /* ── The demo ─────────────────────────────────────────────
     Structured the way CodeFlows is, which took being told twice:

       The SIDEBAR holds projects and the folders inside them, and
       nothing else. Sidebar.tsx renders FolderRow (and sidebar apps)
       under an expanded project. There is a TerminalRow in that file
       but nothing renders it.

       The TABS are always across the top, and they belong to the
       SELECTED FOLDER. TabBar.tsx:446: `if (t.folderId !==
       activeFolderId) return false`.

     So the strip is rebuilt from FOLDERS whenever you pick a folder,
     rather than being written out once in the markup — the point of
     the demo is that a folder owns its tabs. */
  var demo = document.getElementById('demo');

  if (demo) {
    var strip = document.getElementById('strip');
    var panes = [].slice.call(demo.querySelectorAll('.pane'));
    var flow = document.getElementById('flow');
    var form = document.getElementById('form');
    var input = document.getElementById('input');
    var sugs = document.getElementById('sugs');
    var hint = document.getElementById('hint');
    var ctxEl = document.getElementById('ctx');
    var where = document.getElementById('demoWhere');
    var cap = document.getElementById('demoCap');
    var phoneBtn = document.getElementById('demoPhone');
    var fileName = document.getElementById('fileName');

    /* `new URL(..., import.meta.url)` rather than a plain string, because the
       strip is built in JS and Vite only rewrites asset paths it can see. A
       literal './landing/assets/…' survives the build untouched and then 404s
       against the hashed filename the HTML got — which is exactly how the
       agent icons went missing from every tab. Vite resolves this form at
       build time, so the tabs point at the same hashed file the markup does. */
    function mark(url, round) {
      return '<img src="' + url + '" width="17" height="17"' +
        (round ? ' style="border-radius:3px"' : '') + ' alt="">';
    }
    var MARK = {
      claude: mark(new URL('./assets/agent-claude.png', import.meta.url).href, true),
      codex: mark(new URL('./assets/agent-codex.png', import.meta.url).href),
      gemini: mark(new URL('./assets/agent-gemini.png', import.meta.url).href),
      kimi: mark(new URL('./assets/agent-kimi.png', import.meta.url).href),
      grok: '<svg width="17" height="17"><use href="#i-grok"/></svg>',
      git: '<svg width="17" height="17"><use href="#i-git"/></svg>',
      file: '<svg width="17" height="17"><use href="#i-file"/></svg>',
      globe: '<svg width="17" height="17"><use href="#i-globe"/></svg>'
    };

    /* Each folder owns its tabs. `pane` is which surface a tab shows —
       several folders reuse the same pane with a different label, exactly
       as two projects both have a Git tab. */
    var FOLDERS = {
      checkout: {
        project: 'orbit-web', name: 'Checkout Redesign', file: 'CartSummary.tsx',
        tabs: [
          { id: 'claude', pane: 'claude', icon: 'claude', label: 'Cart Total', live: true },
          { id: 'git', pane: 'git', icon: 'git', label: 'Git' },
          { id: 'file', pane: 'file', icon: 'file', label: 'CartSummary.tsx' },
          { id: 'web', pane: 'web', icon: 'globe', label: 'localhost:5173' }
        ]
      },
      facets: {
        project: 'orbit-web', name: 'Search Filters', file: 'facets.ts',
        tabs: [
          { id: 'codex', pane: 'codex', icon: 'codex', label: 'Facet Counts', live: true },
          { id: 'git', pane: 'git', icon: 'git', label: 'Git' },
          { id: 'file', pane: 'file', icon: 'file', label: 'facets.ts' }
        ]
      },
      ratelimit: {
        project: 'harbour-api', name: 'Rate Limiting', file: 'tokenBucket.ts',
        tabs: [
          { id: 'gemini', pane: 'codex', icon: 'gemini', label: 'Token Bucket' },
          { id: 'file', pane: 'file', icon: 'file', label: 'tokenBucket.ts' }
        ]
      },
      offline: {
        project: 'atlas-mobile', name: 'Offline Sync', file: 'queue.ts',
        tabs: [
          { id: 'kimi', pane: 'codex', icon: 'kimi', label: 'Queue Replay' },
          { id: 'git', pane: 'git', icon: 'git', label: 'Git' }
        ]
      },
      editor: {
        project: 'paperkite', name: 'Editor Toolbar', file: 'Toolbar.tsx',
        tabs: [
          { id: 'grok', pane: 'codex', icon: 'grok', label: 'Toolbar Spacing' },
          { id: 'file', pane: 'file', icon: 'file', label: 'Toolbar.tsx' }
        ]
      }
    };

    var CAPS = {
      claude: 'A real terminal. Type a prompt, or pick one — the agent runs it here.',
      codex: 'Another agent, in its own folder, still running while you look elsewhere.',
      git: 'The diff sits next to the agent that wrote it. No second window.',
      file: 'Drag the seam. The file on one side, the app it changes on the other.',
      web: 'A real browser tab, inside the workspace — pointed at your own dev server.'
    };

    var folderId = 'checkout';
    var tabId = 'claude';

    /* Rebuild the strip for the selected folder. This is the demo's whole
       claim: a folder owns its tabs, so changing folder changes the strip. */
    function renderStrip() {
      var f = FOLDERS[folderId];
      strip.innerHTML = f.tabs.map(function (t) {
        return '<button class="tab' + (t.id === tabId ? ' tab--on' : '') + '" role="tab" type="button"' +
          ' data-tab="' + t.id + '" aria-selected="' + (t.id === tabId ? 'true' : 'false') + '">' +
          (MARK[t.icon] || '') + '<span>' + t.label + '</span>' +
          (t.live ? '<span class="tab__live"></span>' : '') + '</button>';
      }).join('') +
        '<span class="tabs__add"><svg width="14" height="14"><use href="#i-plus"/></svg></span>' +
        '<span class="tabs__fade"></span>';
    }

    function showTab(id) {
      var f = FOLDERS[folderId];
      var t = f.tabs.filter(function (x) { return x.id === id; })[0] || f.tabs[0];
      tabId = t.id;
      panes.forEach(function (p) { p.hidden = p.dataset.pane !== t.pane; });
      demo.dataset.pane = t.pane;
      if (fileName) fileName.textContent = f.file;
      if (cap) cap.textContent = CAPS[t.pane] || '';
      renderStrip();
    }

    function selectFolder(id) {
      folderId = id;
      var f = FOLDERS[id];
      [].slice.call(demo.querySelectorAll('.si--fold')).forEach(function (b) {
        b.classList.toggle('si--on', b.dataset.folder === id);
      });
      if (where) where.textContent = f.project;
      // A folder opens on its first tab, the way selecting one in the app
      // lands you on that folder's active tab rather than a blank strip.
      showTab(f.tabs[0].id);
    }

    strip.addEventListener('click', function (e) {
      var b = e.target.closest('.tab[data-tab]');
      if (b) showTab(b.dataset.tab);
    });

    strip.addEventListener('keydown', function (e) {
      var all = [].slice.call(strip.querySelectorAll('.tab'));
      var i = all.indexOf(document.activeElement);
      if (i < 0) return;
      var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? all.length - 1 : null;
      if (n === null) return;
      e.preventDefault();
      n = (n + all.length) % all.length;
      showTab(all[n].dataset.tab);
      var again = strip.querySelectorAll('.tab')[n];
      if (again) again.focus();
    });

    demo.querySelector('.side').addEventListener('click', function (e) {
      var fold = e.target.closest('[data-folder]');
      if (fold) { selectFolder(fold.dataset.folder); return; }
      var t = e.target.closest('[data-toggle]');
      if (!t) return;
      var node = t.parentElement;
      node.dataset.open = node.dataset.open === '1' ? '0' : '1';
      t.setAttribute('aria-expanded', node.dataset.open === '1' ? 'true' : 'false');
    });

    [].slice.call(demo.querySelectorAll('.side [data-toggle]')).forEach(function (t) {
      t.setAttribute('aria-expanded', t.parentElement.dataset.open === '1' ? 'true' : 'false');
    });

    /* ── Running a prompt ───────────────────────────────────
       Uneven delays on purpose: a call that reads 300 lines should not
       land in the same beat as one that prints a number. */
    var SCRIPTS = {
      flicker: [
        [420, '<span class="orange">✻</span> <span class="dim">Looking at the cart…</span>'],
        [700, '<span class="ok">●</span> Read(<span class="acc">src/checkout/CartSummary.tsx</span>)'],
        [180, '<span class="dim">  ⎿  Read 142 lines</span>'],
        [560, '<span class="ok">●</span> The total is set in a useEffect, so the first render after a'],
        [70, '  quantity change paints the PREVIOUS total. That frame is the'],
        [70, '  flicker.'],
        [620, '<span class="ok">●</span> Update(<span class="acc">src/checkout/CartSummary.tsx</span>)'],
        [220, '<span class="dim">  ⎿  Updated with <span class="ok">6 additions</span> and <span class="del">3 removals</span></span>'],
        [640, '<span class="ok">●</span> Bash(<span class="acc">npm test -- checkout</span>)'],
        [900, '<span class="dim">  ⎿  <span class="ok">✓ 9 passed</span> in 1.2s</span>'],
        [420, '&nbsp;'],
        [80, '<span class="ok">●</span> Derived during render with useMemo. No effect, no stale'],
        [70, '  frame, and the total is right on the first paint.'],
        [520, '@git']
      ],
      tests: [
        [380, '<span class="ok">●</span> Bash(<span class="acc">npm test -- checkout</span>)'],
        [1100, '<span class="dim">  ⎿  <span class="ok">✓ 9 passed</span> · CartSummary</span>'],
        [140, '<span class="dim">  ⎿  <span class="ok">✓ 5 passed</span> · totals</span>'],
        [140, '<span class="dim">  ⎿  <span class="ok">✓ 7 passed</span> · useCart</span>'],
        [420, '&nbsp;'],
        [80, '<span class="ok">●</span> 21 passed in 1.8s. Nothing to fix.']
      ],
      split: [
        [420, '<span class="orange">✻</span> <span class="dim">Opening a split view…</span>'],
        [620, '<span class="ok">●</span> Open(<span class="acc">CartSummary.tsx</span>) │ Open(<span class="acc">localhost:5173</span>)'],
        [420, '<span class="dim">  ⎿  Split 50 / 50 — drag the seam to resize</span>'],
        [500, '@file']
      ],
      generic: [
        [420, '<span class="orange">✻</span> <span class="dim">Looking around the project…</span>'],
        [780, '<span class="ok">●</span> Grep(<span class="acc">src/</span>)'],
        [200, '<span class="dim">  ⎿  Found 28 matches across 9 files</span>'],
        [620, '<span class="ok">●</span> Read(<span class="acc">src/checkout/useCart.ts</span>)'],
        [180, '<span class="dim">  ⎿  Read 96 lines</span>'],
        [640, '&nbsp;'],
        [80, '<span class="ok">●</span> This is a demo, so that is as far as I go — but in the real'],
        [70, '  app this is a live Claude Code session with your account,'],
        [70, '  your permissions and your files.']
      ]
    };

    var running = false;
    var timers = [];

    function line(html) {
      var d = document.createElement('div');
      d.className = 'term__l';
      d.innerHTML = html;
      flow.appendChild(d);
      flow.scrollTop = flow.scrollHeight;
    }

    function stop() {
      timers.forEach(clearTimeout);
      timers = [];
      running = false;
      demo.dataset.running = '0';
      if (hint) hint.textContent = 'Try another — or switch folder while it runs';
      if (sugs) sugs.hidden = false;
      if (input) input.disabled = false;
    }

    function run(name, echo) {
      if (running) return;
      running = true;
      demo.dataset.running = '1';
      if (sugs) sugs.hidden = true;
      if (input) { input.value = ''; input.disabled = true; }
      if (hint) hint.textContent = 'Esc to interrupt';

      line('&nbsp;');
      line('&gt; <b>' + echo.replace(/[<>&]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; }) + '</b>');

      var t = 0;
      (SCRIPTS[name] || SCRIPTS.generic).forEach(function (step) {
        t += step[0];
        timers.push(setTimeout(function () {
          // "@pane" switches tab instead of printing — the agent opening
          // the thing it just made, which is what the real one does.
          if (step[1].charAt(0) === '@') showTab(step[1].slice(1));
          else line(step[1]);
        }, t));
      });

      timers.push(setTimeout(function () {
        if (ctxEl) ctxEl.textContent = Math.max(4, (+ctxEl.textContent || 68) - (3 + Math.floor(Math.random() * 4)));
        stop();
      }, t + 600));
    }

    if (sugs) {
      sugs.addEventListener('click', function (e) {
        var b = e.target.closest('.sug');
        if (b) { selectFolder('checkout'); run(b.dataset.run, b.textContent.trim()); }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim();
        if (v) run('generic', v);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && running) { stop(); line('<span class="dim">  ⎿  Interrupted</span>'); }
    });

    if (phoneBtn) {
      phoneBtn.addEventListener('click', function () {
        var on = demo.dataset.phone === '1';
        demo.dataset.phone = on ? '0' : '1';
        phoneBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
        if (cap) {
          cap.textContent = on
            ? (CAPS[demo.dataset.pane] || '')
            : 'The same session, on a phone. Nothing moved — the desktop is still doing the work.';
        }
        // Folding changes the window's height, so the page reflows under the
        // reader and the thing they just clicked scrolls off screen.
        setTimeout(function () {
          var r = demo.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) {
            demo.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          }
        }, 480);
      });
    }

    selectFolder('checkout');
  }

  /* ── The split divider actually drags ─────────────────── */
  var div = document.getElementById('divider');
  var pa = document.getElementById('splitA');
  if (div && pa){
    var dragging = false;
    var host = div.parentElement;
    var apply = function(clientX){
      var r = host.getBoundingClientRect();
      var pct = (clientX - r.left) / r.width * 100;
      pct = Math.max(24, Math.min(76, pct));
      pa.style.flex = '0 0 ' + pct + '%';
    };
    var down = function(e){
      dragging = true; div.dataset.hot = '1';
      document.body.style.cursor = 'col-resize';
      e.preventDefault();
    };
    div.addEventListener('mousedown', down);
    div.addEventListener('touchstart', down, {passive:false});
    div.addEventListener('mouseenter', function(){ div.dataset.hot = '1'; });
    div.addEventListener('mouseleave', function(){ if (!dragging) div.dataset.hot = '0'; });
    window.addEventListener('mousemove', function(e){ if (dragging) apply(e.clientX); });
    window.addEventListener('touchmove', function(e){
      if (dragging && e.touches[0]){ apply(e.touches[0].clientX); e.preventDefault(); }
    }, {passive:false});
    var up = function(){
      if (!dragging) return;
      dragging = false; div.dataset.hot = '0'; document.body.style.cursor = '';
    };
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
  }
})();
